// Beach Room Configuration

import { Room } from '../config/room-types.js';
import { STANDARD_BOUNDARIES } from '../config/room-constants.js';

export const forestRoom: Room = {
  name: 'Forest',
  background: '/media/club-penguin/forest.jpg',
  spawn: { x: 341, y: 338 },

  colliders: [
    ...STANDARD_BOUNDARIES,
    { x: 21, y: 13, w: 917, h: 115 },
    { x: 892, y: 124, w: 41, h: 342 },
    { x: 31, y: 438, w: 314, h: 85 },
    { x: 19, y: 228, w: 99, h: 207 },
  ],

  hotspots: [
    {
      id: 'forest-to-stadium',
      action: 'goto',
      target: 'stadium',
      spawn: { x: 789, y: 147 },
      x: 28,
      y: 114,
      w: 120,
      h: 82,
    },
    {
      id: 'forest-to-cove',
      action: 'goto',
      target: 'cove',
      spawn: { x: 319, y: 243 },
      x: 744,
      y: 469,
      w: 190,
      h: 54,
    },
  ],
};
